import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import {
  showCohortListhospital,
  deleteNervePost,
} from "../../redux/admin/actions/admin.actions";
import { useParams } from "react-router-dom";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { SyncOutlined } from "@ant-design/icons";
import { Table } from "react-bootstrap";
import style from "./Notify.module.scss";
import { PlusOutlined } from "@ant-design/icons";
import AddHospitalModal from "./AddHospitalModal";
import axiosClient from "../../service/axios";

const NotifyNerveScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataItem, setDataItem] = useState({});
  const [createModal, setCreateModal] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [refId, setrefId] = useState("");

  const dispatch = useDispatch();

  const { showCohortList } = useSelector((state) => state.adminReducer);
  useEffect(() => {
    setLoading(true);
    dispatch(showCohortListhospital(id));
    setLoading(false);
  }, [dispatch, dataUpdated, id]);


  const headers = [
    { key: "hospital", label: "Hospital" },
    { key: "cohort", label: "COHORT" },
    { key: "date", label: "Date" },
  ];

  const handleSuccessPost = () => {
    setDataUpdated(true);
  };

  const handleRow = (item) => {
    const { ref_id, title, message, id } = item;
    const formData = {
      ref_id: ref_id,
      id: id,
      title: title,
      message: message,
    };
    setDataItem(formData);
    setrefId(ref_id);
    setModal(true);
  };

  return (
    <div>
      <h2>Hospital Cohort</h2>
      <div className="d-flex justify-content-between m-3">
        <div className={style.create} onClick={() => setCreateModal(true)}>
          Add hospital <PlusOutlined />
        </div>
      </div>

      <section style={{ maxWidth: "90%", margin: "auto", boxShadow: "1px 2px 10px rgba(112, 144, 176, 0.25)"}}>
        {loading && <LinearLoader />}

        <Table borderless responsive className="" hover>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {showCohortList?.map((item, index) => {
            return (
              <tbody>
                <tr className={style.TableBodyRow} key={index}>
                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.name}
                  </td>
                  <td
                    style={{
                      width: "20vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.hospital}
                  </td>

                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.added}
                  </td>

                  {/* <td style={{ width: "15vw" }}>
                    <button
                      className={`${style.btn}`}
                      style={{ marginRight: "6px" }}
                      onClick={() => handleNavigate(item.id)}
                    >
                      Edit
                    </button>
                    <button
                      style={{ marginLeft: "6px" }}
                      className={`${style.btn}`}
                      onClick={() => handleRow(item)}
                    >
                      Delete
                    </button>
                  </td> */}
                </tr>
              </tbody>
            );
          })}
        </Table>
        <ConfirmationModal
          open={createModal}
          handleClose={() => setCreateModal(false)}
          closemodal={() => setCreateModal(false)}
          bgcolor="white"
          width="45vw"
          instruction={
            <AddHospitalModal
              loading={loading}
              handleSuccessPost={handleSuccessPost}
              refId={refId}
              onClickYes={() => {}}
              setCreateModal={setCreateModal}
            />
          }
        />
        {modal && (
          <Modal
            setModal={setModal}
            dataItem={dataItem}
            handleSuccessPost={handleSuccessPost}
          />
        )}
      </section>
    </div>
  );
};

export default NotifyNerveScreen;

const Modal = ({ setModal, dataItem, handleSuccessPost }) => {
  const dispatch = useDispatch();
  const { id } = dataItem;

  const [showSpinner, setShowSpinner] = useState(false);

  const handleYesButton = () => {
    // dispatch(notifyNervePost(dataItem));
    dispatch(deleteNervePost(id));
    setShowSpinner(true);
    setTimeout(() => {
      setShowSpinner(false);
      setModal(false);
      handleSuccessPost();
      // setIsDeleted(true)
    }, 1500);
  };
  const handleNoButton = () => {
    setModal(false);
  };
  const handleOverlayClick = () => {};
  return (
    <div className={style.overlay} onClick={handleOverlayClick}>
      <div className={style.modalContent}>
        <h4 className={style.headerModal}>Process delete</h4>
        <div className={style.btnContainer}>
          <button className={style.btn} onClick={handleYesButton}>
            {showSpinner ? <SyncOutlined spin /> : "Yes"}
          </button>
          <button className={style.btn} onClick={handleNoButton}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};
